import React from 'react'

// Original vector from Figma frame 220, Polygon 1: the reasons chart's next page arrow.
// The previous page arrow is the same vector mirrored.
const ChartPageArrowIcon = ({ direction = 'next' }) => (
  <svg
    width={11}
    height={19}
    viewBox="475 592 11 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    style={direction === 'previous' ? { transform: 'scaleX(-1)' } : undefined}
  >
    <path d="M476 610L485 601.5L476 593" stroke="#6D6D71" />
  </svg>
)

export default ChartPageArrowIcon
